import { z } from 'zod'

export const loginSchema = z.object({
  email: z.string().min(1, 'Email obrigatório').email('Email inválido'),
  password: z.string().min(1, 'Senha obrigatória'),
})

export const registerSchema = z.object({
  tenantName: z.string().min(2, 'Nome da transportadora é obrigatório'),
  cnpj: z
    .string()
    .min(1, 'CNPJ obrigatório')
    .regex(/^\d{14}$/, 'CNPJ deve conter 14 dígitos numéricos'),
  name: z.string().min(2, 'Nome obrigatório'),
  email: z.string().min(1, 'Email obrigatório').email('Email inválido'),
  password: z.string().min(8, 'Senha deve ter no mínimo 8 caracteres'),
})

export type LoginFormData = z.infer<typeof loginSchema>
export type RegisterFormData = z.infer<typeof registerSchema>
